import { TDealPipeline } from "@/models/deals.model";
import axios from "@utils/axios-instance";

const getAll = async (): Promise<TDealPipeline[]> => {
    const response = await axios.get(`/deal/pipeline`);
    return response.data;
};

const deleteById = async (pipelineId: number): Promise<void> => {
    await axios.delete(`/deal/pipeline/${pipelineId}`);
};

const save = async (pipelineName: string): Promise<TDealPipeline> => {
    const response = await axios.post(`/deal/pipeline`, { name: pipelineName });
    return response.data;
};

const updateById = async (pipelineId: number, name: string): Promise<TDealPipeline> => {
    const response = await axios.patch(`/deal/pipeline/${pipelineId}`, { name });
    return response.data;
};


export default {
    getAll,
    deleteById,
    save,
    updateById
};